<form [formGroup]="registrationForm" class="create-account-form" (submit)="onSubmit($event)" >

  <div class="dx-fieldset">
    <div class="dx-fieldset-header">Credenciales</div>
    <div class="dx-field">
      <div class="dx-field-label">Email</div>
      <div class="dx-field-value">
        <dx-text-box formControlName="email" [inputAttr]="{ 'aria-label': 'Email' }">
          <dx-validator>
            <dxi-validation-rule type="required" message="El email es requerido"></dxi-validation-rule>
            <dxi-validation-rule type="email" message="El email es invalido"></dxi-validation-rule>
            <dxi-validation-rule type="async" message="El email ya se encuentra registrado"
              [validationCallback]="asyncValidation"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Password</div>
      <div class="dx-field-value">
        <dx-text-box formControlName="password" [inputAttr]="{ 'aria-label': 'Password' }" [mode]="passwordMode"
          [(value)]="password" (onValueChanged)="onPasswordChanged()">
          <dxi-button name="password" location="after" [options]="passwordButton"></dxi-button>
          <dx-validator>
            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Confirme Password</div>
      <div class="dx-field-value">
        <dx-text-box formControlName="confirmPassword" [(value)]="confirmPassword" [mode]="confirmPasswordMode"
          [inputAttr]="{ 'aria-label': 'Password' }">
          <dxi-button name="password" location="after" [options]="confirmPasswordButton"></dxi-button>
          <dx-validator #targetValidator>
            <dxi-validation-rule type="required" message="Confirm Password is required"></dxi-validation-rule>
            <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison"
              message="Password and Confirm Password do not match"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
  </div>


  <div class="dx-fieldset">
    <div class="dx-fieldset-header">Informacion personal</div>

    <!-- <div class="dx-field">
      <div class="dx-field-label">Razon Social</div>
      <div class="dx-field-value">
        <dx-text-box value="" formControlName="razonSocial" [inputAttr]="{ 'aria-label': 'Razon Social' }">
        </dx-text-box>
      </div>
    </div> -->

    <div class="dx-field">
      <div class="dx-field-label">Nombre</div>
      <div class="dx-field-value">
        <dx-text-box value="" formControlName="nombre" [inputAttr]="{ 'aria-label': 'Nombre' }">
          <dx-validator>
            <dxi-validation-rule type="required" message="Nombre es requerido"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="namePattern"
              message="No se permite numeros en el nombre"></dxi-validation-rule>
            <dxi-validation-rule type="stringLength" [min]="2"
              message="El nombre debe tener al menos 2 digitos"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>


    <div class="dx-field">
      <div class="dx-field-label">Apellido</div>
      <div class="dx-field-value">
        <dx-text-box formControlName="apellido" value="" [inputAttr]="{ 'aria-label': 'Apellido' }">
          <dx-validator>
            <dxi-validation-rule type="required" message="Apellido es requerido"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="namePattern"
              message="No se permite numeros en el apellido"></dxi-validation-rule>
            <dxi-validation-rule type="stringLength" [min]="2"
              message="El apellido debe tener al menos 2 digitos"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <!-- <div class="dx-field">
      <div class="dx-field-label">Tipo Doc</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="tipoDocumento" displayExpr="Id" valueExpr="Id" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Tipo Documento' }"
          formControlName="tipoDoc" >
        </dx-select-box>
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Nro Documento</div>
      <div class="dx-field-value">
        <dx-text-box formControlName="nroDoc" value="" [inputAttr]="{ 'aria-label': 'Nro Documento' }">
          <dx-validator>
            <dxi-validation-rule type="required" message="El nro de documento es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Condicion fiscal</div>
      <div class="dx-field-value">
          <dx-select-box [dataSource]="condicionFiscal" displayExpr="Nombre" valueExpr="Id" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Condicion fiscal' }"
          formControlName="condicionFiscal"
          >
            <dx-validator>
              <dxi-validation-rule type="required" message="La condicion fiscal es requerida"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Telefono <i>(opcional)</i></div>
      <div class="dx-field-value">
        <dx-text-box [inputAttr]="{ 'aria-label': 'Phone' }" mask="+54 (X00) X000-0000" [maskRules]="phoneRules"
          maskInvalidMessage="El telefono tiene que tener un formato valido" validationMessagePosition="left"
          formControlName="telefono">
          <dx-validator>
            <dxi-validation-rule type="pattern" [pattern]="phonePattern"
              message="El telefono tiene que tener un formato valido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Personeria</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="personeria" displayExpr="Nombre" valueExpr="Id" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Personeria' }"
          formControlName="personeria"
          >
          <dx-validator>
            <dxi-validation-rule type="required" message="La personeria es requerida"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Rol</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="roles" displayExpr="Nombre" valueExpr="Id" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Rol' }"
          formControlName="rol"
          >
          <dx-validator>
            <dxi-validation-rule type="required" message="El pais es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div> -->
  </div>


  <!-- <div class="dx-fieldset">
    <div class="dx-fieldset-header">Direccion de facturacion</div>
    <div class="dx-field">
      <div class="dx-field-label">Pais</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="paises" displayExpr="Nombre" valueExpr="IdPais" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Pais' }" (onValueChanged)="obtenerProvinciaxPais($event)"
          formControlName="pais"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="El pais es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Provincia</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="provinciasxPais" displayExpr="Nombre" valueExpr="IdProvincia"
          validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Provincia' }"
          (onValueChanged)="obtenerLocalidadxProvincia($event)" formControlName="provincia"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="El pais es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Localidad</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="localidadesxProvincia" displayExpr="Nombre" valueExpr="IdLocalidad"
          validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Localidad' }" formControlName="localidad"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="La localidad es requerida"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>


    <div class="dx-field">
      <div class="dx-field-label">Domicilio</div>
      <div class="dx-field-value">
        <dx-text-box validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Address' }"
          formControlName="domicilio">
          <dx-validator>
            <dxi-validation-rule type="required" message="El domicilio es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Codigo Postal</div>
      <div class="dx-field-value">
        <dx-text-box validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Codigo Postal' }"
          formControlName="cp">
          <dx-validator>
            <dxi-validation-rule type="required" message="El codigo postal es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Zona de entrega</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="zonasDeEntrega" displayExpr="Nombre" valueExpr="Id"
          validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Zona de entrega' }" formControlName="zonaDeEntrega"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="La Zona de entrega es requerida"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>

    <div>
      <dx-check-box
        class="direccion-entrega"
        id="check"
        [(value)]="checkboxEntrega_value"
        [elementAttr]="{ 'aria-label': 'Unchecked' }"
        text="Domicilio de entrega distinto a domicilio de facturación"
        [iconSize]="15">
      </dx-check-box>
    </div>
  </div>

  <div class="dx-fieldset" *ngIf="checkboxEntrega_value">
    <div class="dx-fieldset-header">Direccion de entrega</div>
    <div class="dx-field">
      <div class="dx-field-label">Pais</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="paises" displayExpr="Nombre" valueExpr="IdPais" validationMessagePosition="left"
          [inputAttr]="{ 'aria-label': 'Pais' }" (onValueChanged)="obtenerProvinciaxPaisEntrega($event)"
          formControlName="paisEntrega"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="El pais es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>
    <div class="dx-field">
      <div class="dx-field-label">Provincia</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="provinciasxPais" displayExpr="Nombre" valueExpr="IdProvincia"
          validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Provincia' }"
          (onValueChanged)="obtenerLocalidadxProvinciaEntrega($event)" formControlName="provinciaEntrega"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="El pais es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Localidad</div>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="localidadesxProvincia" displayExpr="Nombre" valueExpr="IdLocalidad"
          validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Localidad' }"
          formControlName="localidadEntrega"
          [searchEnabled]="true">
          <dx-validator>
            <dxi-validation-rule type="required" message="La localidad es requerida"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div>


    <div class="dx-field">
      <div class="dx-field-label">Domicilio</div>
      <div class="dx-field-value">
        <dx-text-box validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Domicilio Entrega' }"
          formControlName="domicilioEntrega">
          <dx-validator>
            <dxi-validation-rule type="required" message="El domicilio de entrega es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">Codigo Postal</div>
      <div class="dx-field-value">
        <dx-text-box validationMessagePosition="left" [inputAttr]="{ 'aria-label': 'Codigo Postal Entrega' }"
          formControlName="cpEntrega">
          <dx-validator>
            <dxi-validation-rule type="required" message="El codigo postal de entrega es requerido"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>



  </div> -->


  <!-- <div class="dx-field-value">
      <div>
        <dx-check-box
          id="check"
          [value]="false"
          text="I agree to the Terms and Conditions"
        >
          <dx-validator>
            <dxi-validation-rule
              type="compare"
              [comparisonTarget]="checkComparison"
              message="You must agree to the Terms and Conditions"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-check-box>
      </div>
    </div> -->


  <div class="dx-fieldset">
    <dx-validation-summary id="summary"></dx-validation-summary>

    <dx-button width="100%" id="button" text="Registrarse" type="success" [useSubmitBehavior]="true">
    </dx-button>
  </div>

</form>
